export default {
  title: 'Configurar entregas de paquetes',
  form: {
    title: 'Crear entrega',
    companies: {
      label: 'Empresas',
    },
  },
  table: {
    title: 'Historial de entregas',
    fields: {
      name: 'Empresa',
      fulfilled: 'Entregado el',
    },
  },
  buttons: {
    create_fulfillment: 'Crear entrega',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
    failed_to_create_fulfillment: 'Error al crear la entrega',
  },
};
